import { render, staticRenderFns } from "./Highlights.vue?vue&type=template&id=5a919e7e&scoped=true"
import script from "./Highlights.vue?vue&type=script&lang=ts"
export * from "./Highlights.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a919e7e",
  null
  
)

export default component.exports